import * as React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './index.module.less';
import { H5 } from '@/components';
import classNames from 'classnames';
import { Wrapper } from '../Header';
import { TOOL_ENTRIES_JA, USE_CASES_ENTRIES_JA } from '@/constants/layout';

interface IProps {
  isMediaTool: boolean;
  isNewLayout?: boolean;
}

const FooterLinkList = (props: IProps) => {
  const { isMediaTool, isNewLayout = false } = props;
  const LinkWrapper = Wrapper(isMediaTool);

  return (
    <div className={classNames(styles.footer, isNewLayout && styles.new_home_page_footer)}>
      <div
        className={styles.footer_external_links}
        // style={{ justifyContent: isMediaTool ? 'initial' : 'space-between' }}
      >
        {/* iframe */}
        {!isMediaTool && (
          <div className={styles.footer_iframe_container}>
            <h3 className="heading-4-new left-aligned">最新機能やキャンペーンなどをお届け</h3>
            <div className="form-wrapper-new subscription w-form">
              <iframe
                loading="lazy"
                data-src="https://tally.so/embed/wMeNgM?alignLeft=1&hideTitle=1&transparentBackground=1"
                height={180}
                className={`lozad ${styles.iframe}`}
                title="最新機能やキャンペーンなどをお届け"
              />
              <div className="success-message-new w-form-done">
                <p id="edm_subscribe_success" className="caption left-aligned white">
                  ご購読ありがとうございます。
                </p>
              </div>
              <div className="error-message w-form-fail">
                <p className="caption left-aligned white">おっと!フォームを送信する際に何か問題が発生しました。</p>
              </div>
            </div>
          </div>
        )}
        {/* 第三方按钮 */}
        <div className={styles.footer_three_part_btn}>
          <div className={styles.footer_btn_container}>
            <a
              id="footer_appstore_icon"
              href="https://apps.apple.com/app/id1480649572"
              target="_blank"
              // className="link-block-new badge w-inline-block"
              rel="noreferrer"
            >
              <StaticImage
                src="../../../images/btn-appstore-jp2x.png"
                loading="lazy"
                alt="App Storeからダウンロード"
                style={{ width: '162px' }}
              />
            </a>
            <a
              id="footer_googleplay_icon"
              href="https://play.google.com/store/apps/details?id=com.langogo.transcribe"
              // className="link-block-new badge w-inline-block"
            >
              <StaticImage
                src="../../../images/btn-google-play-jp2x.png"
                loading="lazy"
                alt="Google Playで手に入れよう"
                style={{ width: '162px' }}
              />
            </a>
          </div>
          <div className={styles.footer_star_container}>
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/アプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <StaticImage
              src="../../../images/Nottaアプリ評価.png"
              loading="lazy"
              alt="star"
              className={styles.footer_score_star}
            />
            <p style={{ marginBottom: '0px' }}>163万ダウンロード突破！</p>
          </div>
        </div>
        {/* 社交媒体 */}
        <div>
          <a
            id="footer_twitter_icon"
            href="https://twitter.com/JapanNotta"
            target="_blank"
            className="link-block-new social-media-logo w-inline-block"
            rel="noreferrer"
          >
            <StaticImage
              src="../../../images/614c2f7976b47827fdabfdd9_Twitter.png"
              loading="lazy"
              alt="Twitter"
              height={28}
              width={28}
            />
          </a>
          <a
            id="footer_youtube_icon"
            href="https://www.youtube.com/channel/UCLcc5s8xxJGMoxgPBtYLmKw/featured"
            target="_blank"
            className="link-block-new social-media-logo w-inline-block"
            rel="noreferrer"
          >
            <StaticImage
              src="../../../images/614c2f7976b4783edbabfdd6_Youtube.png"
              loading="lazy"
              width={28}
              alt="YouTube"
            />
          </a>
          <a
            id="footer_tiktok_icon"
            href="https://www.tiktok.com/@notta_japan"
            target="_blank"
            className="link-block-new social-media-logo w-inline-block"
            rel="noreferrer"
          >
            <StaticImage
              src="../../../images/614c2f7976b4781b9babfdd8_Tik-Tok.png"
              loading="lazy"
              width={28}
              alt="TikTok"
            />
          </a>
          <a
            id="footer_facebook_icon"
            href="https://www.facebook.com/Notta%E3%83%8E%E3%83%83%E3%82%BF-102040918784359/?ref=pages_you_manage"
            target="_blank"
            className="link-block-new social-media-logo w-inline-block"
            rel="noreferrer"
          >
            <StaticImage
              src="../../../images/614c2f7976b4783d99abfdd7_Facebook.png"
              loading="lazy"
              width={28}
              alt="Facebook"
            />
          </a>
        </div>
      </div>

      <div className={styles.link_list}>
        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-1.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_1)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={classNames(styles.title_text_mask, styles.title_text)}>プロダクト</H5>
          </div>
          <LinkWrapper to="/web" className="text-link-new footer">
            Web版
          </LinkWrapper>
          <LinkWrapper to="/mobile" className="text-link-new footer">
            アプリ
          </LinkWrapper>
          <LinkWrapper to="/chrome-extension" id="footer-extension" className="text-link-new footer">
            Chrome拡張機能
          </LinkWrapper>
          <LinkWrapper to="/public" className="text-link-new footer">
            Nottaレビュー
          </LinkWrapper>
          <LinkWrapper to="/pricing" className="text-link-new footer">
            料金プラン
          </LinkWrapper>
        </div>
        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-2.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_center)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={styles.title_text}>お役立ち情報</H5>
          </div>
          <a href="https://www.notta.ai/blog" target="_self" className="text-link-new footer">
            ブログ
          </a>
          <LinkWrapper to="/company" className="text-link-new footer">
            会社概要
          </LinkWrapper>
          <LinkWrapper to="/about" className="text-link-new footer">
            資料請求
          </LinkWrapper>
          <LinkWrapper to="/news" className="text-link-new footer">
            新着情報
          </LinkWrapper>
          <LinkWrapper to="/media-kit" className="text-link-new footer">
            メディアキット
          </LinkWrapper>
          <LinkWrapper to="/resources" className="text-link-new footer">
            リサーチ資料
          </LinkWrapper>
        </div>
        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-3.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_right)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={classNames(styles.title_text, styles.title_text_mask)}>連絡情報</H5>
          </div>
          <LinkWrapper to="/inquiry" className="text-link-new footer">
            お問い合わせ
          </LinkWrapper>
          <LinkWrapper to="/request" className="text-link-new footer">
            領収書発行依頼
          </LinkWrapper>
          <LinkWrapper to="/recruit" className="text-link-new footer">
            採用情報
          </LinkWrapper>
          <a href="https://support.notta.ai/hc/ja" target="_blank" className="text-link-new footer" rel="noreferrer">
            ヘルプセンター
          </a>
          <a href="/education-plan" target="_blank" className="text-link-new footer" rel="noreferrer">
            学割・教職員割引
          </a>
          <LinkWrapper to="/guides" className="text-link-new footer">
            よくあるご質問
          </LinkWrapper>
        </div>

        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-4.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_4)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={classNames(styles.title_text, styles.title_text_mask)}>無料テンプレート</H5>
          </div>
          <div role="list item">
            <a href="/templates/objectives-and-key-results" target="_blank" className="text-link-new footer">
              🎈OKR 進捗
            </a>
          </div>
          <div role="list item">
            <a href="/templates/campaign-proposal" target="_blank" className="text-link-new footer">
              📈イベント企画書
            </a>
          </div>
          <div role="list item">
            <a href="/templates/to-do-list" target="_blank" className="text-link-new footer">
              💡To-Do リスト
            </a>
          </div>
          <div role="list item">
            <a href="/templates/task-management" target="_blank" className="text-link-new footer">
              👨‍💻タスク管理
            </a>
          </div>
          <div role="list item">
            <a href="/templates/meetings-notes" target="_blank" className="text-link-new footer">
              📝議事録
            </a>
          </div>
        </div>
        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-5.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_right, styles.title_decoration_5)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={classNames(styles.title_text, styles.title_text_mask)}>活用シーン</H5>
          </div>
          {USE_CASES_ENTRIES_JA.map((entry, index) => (
            <div key={index} role="list item">
              <LinkWrapper to={`${entry.url}`} target="_self" className="text-link-new footer" id={entry.label}>
                {entry.label}
              </LinkWrapper>
            </div>
          ))}
        </div>
        <div className={styles.link_container}>
          <div className={styles.link_list_title}>
            {/* <StaticImage
              src="../../../images/home/link-title-decoration-6.png"
              alt="プロダクト"
              className={classNames(styles.title_decoration, styles.title_decoration_right, styles.title_decoration_6)}
              style={{ position: 'absolute' }}
            /> */}
            <H5 className={classNames(styles.title_text, styles.title_text_mask)}>無料ツール</H5>
          </div>
          {TOOL_ENTRIES_JA.map((entry, index) => (
            <div key={index} role="list item">
              <a href={`${entry.url}`} target="_self" className="text-link-new footer" id={entry.label}>
                {entry.label}
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterLinkList;
